<template>

<div>
  <PageTitle :route="$route">
    <!-- <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template> -->
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <FrotaDriverList />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import FrotaDriverList from '@/components/settings/frota/driver/FrotaDriverList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'FrotaDriver',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    FrotaDriverList
  },
  // methods: {
  //   onClickButton (e) {
  //     this.$router.push({ name: 'addfrotadriver' })
  //   }
  // }
}
</script>
